// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R97q","question":"styles_question__3RW-L","inputVisibleButton":"styles_inputVisibleButton__3wltd","note":"styles_note__3OZP5"};